<template>
<div>
    <div class="col-md-12">
        <div class="row" style="margin-top: 20px">
            <div class="col-md-6">
                <h3 class="page-header">
                    <i class="fa fa-truck animated bounceInDown show-info"></i>
                    <span>Dispatch &amp; Returns</span>
                </h3>
            </div>
            <div class="col-md-6 text-right" style="margin-top:20px">
                <button class="btn btn-sm" :class="tab == 'dispatch' ? 'btn-primary' : 'btn-default'" @click="setTab('dispatch')">To be Dispatched</button>
                <button class="btn btn-sm" :class="tab == 'dispatched' ? 'btn-primary' : 'btn-default'" @click="setTab('dispatched')">Dispatched</button>
                <button class="btn btn-sm" :class="tab == 'returns' ? 'btn-primary' : 'btn-default'" @click="setTab('returns')">Receive Rejected Orders</button>
            </div>
        </div>
    </div>
    <to-dispatch v-if="tab == 'dispatch'" embedded></to-dispatch>
    <dispatched-orders v-else-if="tab == 'dispatched'"></dispatched-orders>
    <receive-returns v-else embedded></receive-returns>
</div>
</template>
<script>
import ToDispatch from './ToDispatch.vue'
import ReceiveReturns from './ReceiveReturns.vue'
import DispatchedOrders from './DispatchedOrders.vue'
const TABS = ['dispatch', 'dispatched', 'returns']
// One page for the Assign To employee: approved orders to dispatch with the
// serial no., the orders he dispatched and their delivery status, and
// rejected orders whose product he receives back.
// ?tab=dispatched / ?tab=returns open those tabs (/receiveorders redirects here).
export default {
    components: { ToDispatch, ReceiveReturns, DispatchedOrders },
    data() {
        return {
            tab: TABS.includes(this.$route.query.tab) ? this.$route.query.tab : 'dispatch'
        }
    },
    watch: {
        '$route.query.tab'(value) {
            this.tab = TABS.includes(value) ? value : 'dispatch'
        }
    },
    methods: {
        setTab(tab) {
            if (tab == this.tab) return
            this.tab = tab
            this.$router.replace({ path: '/todispatch', query: tab == 'dispatch' ? {} : { tab: tab } })
        }
    }
}
</script>
